import React from 'react';
import { Box, Flex, Input, Text } from '@chakra-ui/react';
import { FieldError, RegisterOptions } from 'react-hook-form';

interface IFormInput {
  name: string;
  register: Function;
  ph?: string;
  type?: 'text' | 'number' | 'email';
  registerOptions?: RegisterOptions;
  error?: FieldError;
}

const FormInput: React.FC<IFormInput> = ({
  register,
  name,
  ph = '',
  type = 'text',
  registerOptions = {},
  error,
}) => {
  return (
    <Box>
      <Flex alignItems={'center'}>
        {!!ph && (
          <Text w={'15rem'} mr={4}>
            {ph}:
          </Text>
        )}
        <Input
          {...register(name, registerOptions)}
          placeholder={ph}
          type={type}
          isInvalid={!!error}
        />
      </Flex>
      {error && (
        <Text color="red.500" fontSize="sm" ml="9.7rem" pl={4}>
          {error.message || 'Required field'}
        </Text>
      )}
    </Box>
  );
};

export default FormInput;
